// PhoneRequiredDialog stays closed once the visitor dismisses it. When they then try to send a request, the
// sender asks for it again through this event.
export const REQUIRE_PHONE_VERIFICATION_EVENT = 'ofair:require-phone-verification';

export const requirePhoneVerification = (): void => {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(REQUIRE_PHONE_VERIFICATION_EVENT));
};
